import { render, staticRenderFns } from "./SuccessIcon.vue?vue&type=template&id=5c0fe133"
import script from "./SuccessIcon.vue?vue&type=script&lang=ts"
export * from "./SuccessIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports